import { useTranslation } from "@shared/utils/internationalization";
import Text from "@ui-kit/typography/Text/Text.web";
import { RemainingInventoryBadgeProps } from "./RemainingInventoryBadge.props";

const RemainingInventoryBadge = ({
  remainingTickets,
  className,
}: RemainingInventoryBadgeProps) => {
  const { t } = useTranslation("common");

  return (
    <Text
      className={className}
      display="inline-block"
      fontSize="xs"
      lineHeight="14px"
      fontWeight="bold"
      color="secondary.600"
    >
      {t("{{count}} Tickets Remaining", { count: remainingTickets })}
    </Text>
  );
};

export default RemainingInventoryBadge;
